import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">

      <p class="mb-3 bold text-center">* * *</p>

      <p class="poem-block mb-3">
        Vivis avino kaj avo <br/>
        Apud la bordo de l’ maro. <br/>
        La avo estis fiŝisto. <br/>
        En iu tag’ sensukcese <br/>
        Fiŝkaptis li, fiŝkaptadis, <br/>
        Kaj nur en la fino de l’ tago <br/>
        Kaptis li oran fiŝeton. <br/>
        Ekpetis lin ora fiŝeto: <br/>
        «Forlasu min, kara avĉjo! <br/>
        Se vi permesos la fuĝon, <br/>
        Mi vian deziron plenumos, <br/>
        Kian ajn via kapo elpensos!» <br/>
        Kompatis lin bona fiŝisto <br/>
        Kaj forlasis al la maro senpage. <br/>
        Revenis li al sia hejmo <br/>
        Kaj rakontas pri l’ tagaj eventoj: <br/>
        «Hodiaŭ kaptis mi fiŝon, <br/>
        Ne simplan – la Oran Fiŝeton! <br/>
        Ŝi proponis plenumi dezirojn, <br/>
        Kiajn ajn mia kapo elpensos, <br/>
        Sed mi kompatis la povran, <br/>
        Ŝin forlasis al maro senpage». <br/>
        Ekkoleris severa avino: <br/>
        «Stultulaĉo vi, sencerbulo! <br/>
        Kial vi ŝin forlasis senpage?! <br/>
        Iru, voku la Oran Fiŝeton, <br/>
        Kaj transdonu al ŝi mian peton: <br/>
        -Mi ne volas esti avino, <br/>
        Volas esti mi esperantistino!» <br/>
        Obeeme revenis la avo <br/>
        Al la bordo de Nigra maro <br/>
        Kaj vokas la Oran Fiŝeton: <br/>
        «Venu, treestimata Fiŝeto, <br/>
        Havas peton ja mia avinjo: <br/>
        Ŝi ne volas avino resti, <br/>
        Volas esti ŝi esperantistino». <br/>
        Aperis el maltrankvilaj ondoj <br/>
        La Ora Fiŝeto kaj diras: <br/>
        «Malstreĉiĝu, revenu hejmen, <br/>
        Jam via deziro plenumiĝis». <br/>
        Revenis la avo hejmen <br/>
        Kaj kion, imagu, li vidas?! <br/>
        Estas jam la avin’ esperantistino! <br/>
        Ŝi per voĉo malbona krias: <br/>
        «Mi ne volas esti esperantistino simpla, <br/>
        Deziras mi gitarludi <br/>
        Kaj kanti, kiel Nataŝa Berce!» <br/>
        Denove la av’ kompatinda <br/>
        Revenas al Nigra maro <br/>
        Kaj petas la Oran Fiŝeton: <br/>
        «Venu, treestimata Fiŝeto! <br/>
        Ne satiĝis ja mia avino, <br/>
        Ŝi ne volas esti simpla e-ino, <br/>
        Deziras ŝi gitarludi <br/>
        Kaj kanti, kiel Nataŝa Berce!» <br/>
        Respondis al li la Fiŝeto <br/>
        El nigraj ondoj de l’ maro: <br/>
        «Malstreĉiĝu, revenu hejmen, <br/>
        Jam via deziro plenumiĝis». <br/>
        Sed  kiam revenis li hejmen, <br/>
        Ekvidis teruran scenon: <br/>
        Plen-plena domo de gastoj, <br/>
        Ili fumas, manĝas kaj kantas, <br/>
        Kaj inter ili avin’ kun gitaro, <br/>
        Kun dika-dika kantaro, <br/>
        Kiu enhavas tricent mil kantojn. <br/>
        Ektremis la av’, ŝanceliĝis <br/>
        Kaj ekkuris li tuj al maro <br/>
        Vokante kun la tuta forto:
      </p>

      <p class="poem-block mb-3">
        «Venu, treestimata fiŝeto, <br/>
        Plenumu jam mian peton: <br/>
        Forprenu mian avinon, <br/>
        Proponu al ŝi EOLA’n, <br/>
        Ke ŝi tie ludu kaj kantu!» <br/>
        Svingis la voston fiŝeto <br/>
        Kaj respondis kun gaja rideto:
      </p>

      <p class="poem-block mb-3">
        «Malstreĉiĝu, revenu hejmen, <br/>
        Jam via deziro plenumiĝis.» <br/>
        Revenis la av’ – jen avino <br/>
        Lin batas per ambaŭ manoj:
      </p>

      <p class="poem-block mb-3">
        «De kie invitil’ nenormala, <br/>
        Ja ne estas sigelo stampita, <br/>
        Nur steletoj anstataŭ nomo: <br/>
        Ĉu mi venos al Rusio sen vizo?» <br/>
        Jen ambaŭ ili kuris al maro <br/>
        Kaj vokas la Oran Fiŝeton:
      </p>

      <p class="poem-block mb-3">
        «Venu, treestimata Fiŝeto, <br/>
        Kaj plenumu nian komunan peton: <br/>
        Lasu nin veturi al EOLA aux BET’o <br/>
        Sen invitil’, nek sigeloj, nek vizoj». <br/>
        Nenion respondis fiŝeto <br/>
        Kaj plonĝis profunden en maro. <br/>
        Sed av’ kaj avino revenis <br/>
        Al sia Nigramara bordo. <br/>
        Jam ne estas ili esperantistoj <br/>
        Kaj ne revas plu pri tendaroj.
      </p>
    </div>
    `
  )
}


const itemName = {
  esp: 'Ora Fiŝeto (fabelo el postsovetiaj tempoj)'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;









